var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4 py-4"},[(_vm.meta.version == '1' || _vm.meta.version=='2' || _vm.meta.version=='ext1')?_c('div',[_c('p',[_vm._v(" No additional details??? If not, ill remove this panel + details icon/button ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }